import { useComponentWidth } from "@/components/hooks/use-component-width";
import { HorizontalScroll } from "@/components/shared/horizontal-scroll";
import { Image, View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { useRef } from "react";
import type { HorizontalScrollRef } from "@/components/shared/horizontal-scroll/lib";
import { getPlatform } from "@/lib/utils";

export function RateVisitImageScroll({
  imageUrls,
  onScrollIndexChange,
}: {
  imageUrls: string[];
  onScrollIndexChange?: (index: number) => void;
}) {
  const { width, ref, onLayout } = useComponentWidth();
  const scrollRef = useRef<HorizontalScrollRef>(null);
  return (
    <View className="relative">
      <View {...({ ref, onLayout } as React.ComponentProps<typeof View>)} />
      {width > 0 && (
        <>
          <HorizontalScroll
            ref={scrollRef}
            data={imageUrls}
            snap="start"
            itemWidth={width}
            onScrollIndexChange={onScrollIndexChange}
            renderItem={(image, index) => (
              <View className="h-full max-h-[50dvh] min-w-[200px] overflow-scroll rounded-lg">
                <Image
                  src={image}
                  alt={`Review Image ${index + 1}`}
                  className="h-full w-full object-contain"
                  contentFit="contain"
                />
              </View>
            )}
          />
          {getPlatform() === "web" && (
            <>
              <IconButton
                variant="tertiary"
                color="foreground"
                iconName="arrowLeft"
                rounded="full"
                className="absolute left-4 top-1/2 -translate-y-1/2 p-2"
                size="lg"
                onClick={() => scrollRef.current?.prev()}
              />
              <IconButton
                variant="tertiary"
                color="foreground"
                iconName="arrowRight"
                rounded="full"
                className="absolute right-4 top-1/2 -translate-y-1/2 p-2"
                size="lg"
                onClick={() => scrollRef.current?.next()}
              />
            </>
          )}
        </>
      )}
    </View>
  );
}
